import {formatDate} from "mojave/date/format";

/**
 *
 * @param {Date} date
 * @returns string
 */
export function formatTechnicalDate (date)
{
	const zerofill = (number) => ("" + number).padStart(2, "0");

	return date.getFullYear() + "-" + zerofill(date.getMonth() + 1) + "-" + zerofill(date.getDate());
}

/**
 * @param {string|Date} givenDate
 */
export function isNextMonth (givenDate)
{
	const today = new Date();
	const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1, 0, 0, 0);
	const date = parseDate(givenDate);

	return formatTechnicalDate(nextMonth) === formatTechnicalDate(date);
}


/**
 * @param {string|null} startDate
 * @returns Date[]
 */
export function generateStartMonths (startDate)
{
	const today = new Date();
	const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1, 0, 0, 0);
	const firstDay = parseDate(startDate);

	const firstMonth = null !== firstDay && firstDay > nextMonth
		? firstDay
		: nextMonth;

	return [
		firstMonth,
		new Date(firstMonth.getFullYear(), firstMonth.getMonth() + 1, 1, 0, 0, 0),
		new Date(firstMonth.getFullYear(), firstMonth.getMonth() + 2, 1, 0, 0, 0),
	];
}


/**
 *
 * @param {string|null|Date} date
 * @returns Date|null
 */
export function parseDate (date)
{
	if (date instanceof Date)
	{
		date.setHours(0, 0, 0);
		return date;
	}

	if (typeof date === "string")
	{
		const parsed = new Date(date);
		parsed.setHours(0, 0, 0);
		return parsed;
	}

	return null;
}

/**
 *
 * @param {Date} date
 * @param {string|null} startDate
 */
export function getSelectionDateLabel (date, startDate)
{
	const parsedStartDate = parseDate(startDate);

	if ((!parsedStartDate || !isNextMonth(parsedStartDate)) && isNextMonth(date))
	{
		return "Ab sofort";
	}

	return formatDate(date);
}
